import { Box, Center, Heading, SimpleGrid, Stack, Text } from '@chakra-ui/react';
import '@fontsource/manrope/400.css';
import '@fontsource/manrope/600.css';
import '@fontsource/manrope/800.css';
import { CheckboxContainer } from 'formik-chakra-ui';
import CreateProfileButton from '../CreateProfileButton';
import { FormStep } from '../MultiStepForm';

export default function Compensation(props: {
    onSubmit: any;
    compensation: any;
    setCompensation: any;
    formError: any;
    validationSchema: any;
}) {
    const { onSubmit, compensation, setCompensation, formError, validationSchema } = props;
    const handleCompensationCheckboxChange = (e: any) => {
        let compensationCopy = [...compensation];
        if (compensationCopy.includes('')) {
            compensationCopy.pop();
        }
        if (compensationCopy.includes(e.target.value)) {
            compensationCopy.splice(compensationCopy.indexOf(e.target.value), 1);
            setCompensation([...compensationCopy]);
        } else setCompensation([...compensationCopy, e.target.value]);
    };

    const hourlyPay: string[] = [
        "I'm Flexible",
        '$15-20/hour',
        '$20-30/hour',
        '$30-40/hour',
        '$40+/hour'
    ];

    const salaries: string[] = [
        '$40-50k/year',
        '$50-60k/year',
        '$60-70k/year',
        '$70-80k/year',
        '$85k+/year'
    ];

    const hourlyCompensationOptions = hourlyPay.map((salary) => {
        return (
            <CreateProfileButton
                type="careers"
                name="compensation"
                text={salary}
                key={salary}
                column
                onChange={handleCompensationCheckboxChange}
                isChecked={compensation.includes(salary)}
            />
        );
    });

    const salaryCompensationOptions = salaries.map((salary) => {
        return (
            <CreateProfileButton
                type="careers"
                name="compensation"
                text={salary}
                key={salary}
                column
                onChange={handleCompensationCheckboxChange}
                isChecked={compensation.includes(salary)}
            />
        );
    });

    return (
        <FormStep stepName="compensation" onSubmit={onSubmit} formError={formError} validationSchema={validationSchema}>
            <Center>
                <Box w="788px" h="24rem">
                    <Stack>
                        <Heading fontSize="32px" fontWeight={800} width="800px">
                            What compensation would you consider for a role?
                        </Heading>
                        <Text fontWeight={400} fontSize="15px" color="#686672">
                            Select all that apply.
                        </Text>
                        <Box>
                            <SimpleGrid
                                columns={2}
                                spacingX="38px"
                                spacingY={3}
                                mb={24}
                                h="100px"
                                alignSelf="center"
                            >
                                <CheckboxContainer name="compensation" h="48px">
                                    <Box align="right">{hourlyCompensationOptions}</Box>
                                </CheckboxContainer>
                                <CheckboxContainer
                                    name="compensation"
                                    h="48px"
                                    alignItems="left"
                                    ml="-24px"
                                >
                                    <Box align="left">{salaryCompensationOptions}</Box>
                                </CheckboxContainer>
                            </SimpleGrid>
                        </Box>
                    </Stack>
                </Box>
            </Center>
        </FormStep>
    );
}
